/** 스키마를 통과하기 전의 날것. `templatePayloadSchema.parse` 로 기본값이 채워진다. */
export const TEMPLATE_STARTERS = {
    announcement: {
        badge: '공지',
        title: '공지 제목을 입력하세요',
        body: '본문은 한두 문장으로 짧게 씁니다. 멀리서 읽으므로 길면 어차피 안 읽힙니다.',
        date: new Date().toISOString().slice(0, 10).replace(/-/g, '.'),
        author: '담당 부서',
        notices: [
            { title: '두 번째 공지', dept: '총무팀' },
            { title: '세 번째 공지', dept: 'IT지원팀' },
        ],
        weather: { temperature: '18°C', condition: '맑음', place: '본사' },
        ticker: { label: 'NEWS', content: '하단에 흐르는 문구입니다. 여러 소식을 | 로 구분해 이어 쓰세요.' },
    },
    promotion: {
        badge: '이벤트',
        title: '이벤트 이름',
        titleAccent: '강조할 부분',
        body: '무엇을, 누가, 어떻게 신청하는지 한 문장으로.',
        amountLabel: '연간 지원금',
        amount: '최대 000만원',
        benefits: [
            { icon: 'star', title: '첫 번째 혜택', description: '간단한 설명' },
            { icon: 'heart', title: '두 번째 혜택', description: '간단한 설명' },
        ],
        // 2주 뒤 자정. 카운트다운이 살아 있는 상태로 시작한다.
        deadline: startOfDayIn(14),
        deadlineLabel: '신청 마감까지',
        qr: { caption: 'QR코드로 신청', hint: '카메라로 스캔하세요' },
        ticker: { label: 'EVENT', content: '신청 방법과 마감을 안내하는 문구를 넣으세요.' },
    },
    alert: {
        label: '긴급 알림',
        iconLabel: '시스템 점검',
        title: '무엇이 언제 일어나는지 한 줄로',
        stats: [
            { label: '점검 시간', value: '18:00 - 22:00' },
            { label: '소요 시간', value: '약 4시간' },
        ],
        actions: ['지금 해야 할 일을 씁니다', '두 번째 조치', '문의처: 내선 0000'],
        ticker: { label: '긴급', content: '긴급 상황과 문의처를 반복해 안내합니다.' },
    },
    schedule: {
        heading: '오늘의 일정',
        events: [
            { time: '09:00', title: '첫 번째 일정', location: '장소' },
            { time: '13:00', title: '두 번째 일정', location: '장소' },
            { time: '16:00', title: '세 번째 일정', location: '장소' },
        ],
        countdown: { label: 'D-7', title: '다가오는 날' },
        upcoming: {
            label: '다가오는 이벤트',
            title: '행사 이름',
            items: [
                { icon: 'calendar', text: '날짜와 시각' },
                { icon: 'mapPin', text: '장소' },
                { icon: 'users', text: '참석 대상' },
            ],
        },
        stats: {
            heading: '이번 주 일정',
            items: [
                { value: '0', label: '전체' },
                { value: '0', label: '회의' },
                { value: '0', label: '교육' },
                { value: '0', label: '행사' },
            ],
        },
        ticker: { label: 'SCHEDULE', content: '일정 관련 안내를 넣으세요.' },
    },
    dashboard: {
        // KPI 넷이 기본 배치다 — 아래 차트·순위·진행률의 칸과 경계가 맞는다. 둘 이하면 가로로 넓은 카드가 된다.
        kpis: [
            { label: '지표 이름', value: '0', change: '+0% 전월 대비', up: true, icon: 'dollar', tone: 'blue' },
            { label: '지표 이름', value: '0', change: '+0% 전월 대비', up: true, icon: 'userPlus', tone: 'green' },
            { label: '지표 이름', value: '0', change: '+0% 전월 대비', up: true, icon: 'check', tone: 'purple' },
            { label: '지표 이름', value: '0', change: '+0% 전월 대비', up: true, icon: 'star', tone: 'orange' },
        ],
        chart: {
            title: '추이',
            categories: ['1월', '2월', '3월', '4월'],
            series: [{ name: '올해', tone: 'blue', values: [40, 60, 80, 100] }],
        },
        leaderboard: {
            title: '순위',
            live: false,
            rows: [
                { name: '첫 번째', dept: '소속', score: '0' },
                { name: '두 번째', dept: '소속', score: '0' },
                { name: '세 번째', dept: '소속', score: '0' },
            ],
        },
        progress: {
            title: '진행률',
            rows: [
                { name: '항목 이름', percent: 70 },
                { name: '항목 이름', percent: 40 },
                { name: '항목 이름', percent: 55 },
            ],
        },
        ticker: { label: 'LIVE', content: '실적 관련 안내를 넣으세요.' },
    },
    // 그림·영상은 비워 둔다 — 고르기 전에는 장식 무늬가 그 자리를 지킨다.
    split: {
        layout: 'auto',
        mediaSide: 'start',
        media: null,
        badge: '안내',
        title: '제목을 입력하세요',
        body: '그림이나 영상을 보며 읽을 설명을 한두 문장으로 씁니다.',
        points: ['첫 번째 핵심', '두 번째 핵심', '세 번째 핵심'],
        note: '문의 담당 부서',
        ticker: { label: 'NEWS', content: '하단에 흐르는 문구입니다. 여러 소식을 | 로 구분해 이어 쓰세요.' },
    },
    // 시작일은 넉 달 전 — 미리보기에 목표 기간의 중간쯤이 보인다. 운영자가 실제 날짜로 바꾼다.
    safety: {
        badge: '무재해',
        title: '무재해 달성 현황',
        team: '안전환경팀',
        startDate: localDateDaysAgo(120),
        multiplier: '1',
        ticker: { label: '안전', content: '작업 전 안전 점검을 생활화합시다 | 보호구는 바르게 착용합니다 | 위험을 보면 바로 알립니다' },
    },
    // 큰 구역은 비워 둔다 — 고르기 전에는 장식 무늬가 자리를 지킨다. 옆 구역은 글로 시작해 무엇이 들어가는지 보인다.
    zones: {
        layout: 'main-side',
        zones: [
            { kind: 'media', items: [], dwellSec: 10 },
            { kind: 'text', badge: '안내', title: '제목을 입력하세요', body: '구역마다 이미지·영상·HTML 을 고르거나 글을 씁니다.' },
        ],
        ticker: { label: 'NEWS', content: '하단에 흐르는 문구입니다. 여러 소식을 | 로 구분해 이어 쓰세요.' },
    },
};
/** 오늘부터 N일 뒤 자정(ISO). 시작 데이터가 매번 달라지지 않게 시각을 끊는다. */
function startOfDayIn(days) {
    const target = new Date();
    target.setHours(0, 0, 0, 0);
    target.setDate(target.getDate() + days);
    return target.toISOString();
}
/** 오늘부터 N일 전의 날짜(`YYYY-MM-DD`, 이 기기의 시간대). */
function localDateDaysAgo(days) {
    const target = new Date();
    target.setDate(target.getDate() - days);
    const pad = (n) => String(n).padStart(2, '0');
    return `${target.getFullYear()}-${pad(target.getMonth() + 1)}-${pad(target.getDate())}`;
}
//# sourceMappingURL=starters.js.map